<template>
  <div class="customer-management-potential">
    <div class="title">
      潜在客户
      <span
        >共 <b>{{ total || 0 }}</b> 个客户</span
      >
    </div>
    <div class="subject">
      <div class="search">
        <!-- 固定搜索条件 -->
        <div class="fixed">
          <div class="left">
            <div class="search-item status">
              <div class="search-item-label">客户状态:</div>
              <div class="search-item-comp">
                <el-radio-group
                  size="medium"
                  @change="followStatusChange"
                  v-model="followStatus"
                >
                  <el-radio-button :label="0">全部</el-radio-button>
                  <el-radio-button :label="10">待跟进</el-radio-button>
                  <el-radio-button :label="20">跟进中</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="search-item">
              <div class="specialFocus" @click="attentionChange">
                <i
                  class="iconfont icon-icon-shoucang"
                  style="color: #ff7f2a"
                  v-if="attentionStatus == 20"
                ></i>
                <i class="iconfont icon-icon-shoucangxianxing" v-else></i>
                <span>特别关注</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="search-item search-item-special search-item-specialNew">
              <!-- <el-select
                size="small"
                v-model="searchData.keySelectValue"
                slot="prepend"
                placeholder="请选择"
                @change="keySelectChange"
              >
                <el-option
                  v-for="item in keywordOptions"
                  :label="item.name"
                  :value="item.key"
                  :key="item.key"
                ></el-option>
              </el-select> -->
              <!--   v-if="searchData.keySelectValue"-->
              <el-input
                placeholder="客户名称/联系人姓名/手机/邮箱/备注"
                v-model="searchData.keyword"
                class="input-with-select"
                size="small"
                clearable
                @keyup.enter.native="search"
              >
                <el-button
                  size="small"
                  slot="append"
                  icon="iconfont icon-icon-fangdajing"
                  @click="search"
                ></el-button>
              </el-input>
              <!-- <div class="select-btn" v-else>
                <el-select
                  size="small"
                  multiple
                  collapse-tags
                  v-model="searchData.tags"
                >
                  <el-option
                    v-for="item in tagList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
                <el-button size="small" @click="search">
                  <i class="iconfont icon-icon-fangdajing"></i>
                </el-button>
              </div> -->
            </div>
            <div class="unfold-btn">
              <el-button
                size="medium"
                type="text"
                @click="handleUnfold()"
                v-if="!isUnfold"
              >
                <i class="iconfont icon-icon-shaixuan"></i>
                展开筛选</el-button
              >
              <el-button
                size="medium"
                type="text"
                @click="handleUnfold()"
                v-else
              >
                <i class="iconfont icon-icon-shaixuan"></i>
                收起筛选</el-button
              >
            </div>
          </div>
        </div>
        <!-- 收缩的搜索条件 -->
        <div class="shrink" ref="shrink">
          <div class="top">
            <div class="search-item search-item-time">
              <div class="search-item-label" style="width: 88px">所属行业</div>
              <div class="search-item-comp">
                <el-select
                  v-model="searchData.industry"
                  multiple
                  filterable
                  placeholder="请选择"
                  collapse-tags
                  clearable
                >
                  <el-option
                    v-for="item in customerIndustryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-item search-item-time">
              <div class="search-item-label" style="width: 88px">客户等级</div>
              <div class="search-item-comp">
                <el-select
                  multiple
                  collapse-tags
                  clearable
                  size="small"
                  v-model="searchData.level"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in customerLevelOptions"
                    :key="item.codeValue"
                    :label="item.name"
                    :value="item.codeValue"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-item">
              <div class="search-item-label">区域</div>
              <div class="search-item-comp">
                <TreeSelect
                  v-if="treeSelectShow"
                  ref="treeSelect"
                  @checkChange="areaCheckChange"
                  @reset="treeSelectReset"
                ></TreeSelect>
                <el-select value="" v-else>
                  <option value="1"></option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="search-items">
              <!-- 来源当前版本先去掉 -->
              <!-- <div class="search-item">
                <div class="search-item-label">客户来源</div>
                <div class="search-item-comp">
                  <el-select
                    multiple
                    collapse-tags
                    clearable
                    size="small"
                    v-model="searchData.source"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in customerSourceOptions"
                      :key="item.codeValue"
                      :label="item.name"
                      :value="item.codeValue"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div> -->
              <div class="search-item search-item-time">
                <div class="search-item-label" style="width: 88px">
                  客户添加时间
                </div>
                <div class="search-item-comp">
                  <el-date-picker
                    size="small"
                    v-model="searchData.dateData"
                    type="daterange"
                    value-format="timestamp"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </div>
              <!-- 阅读邮件时间 -->
              <div class="search-item search-item-time">
                <div class="search-item-label" style="width: 88px">
                  阅读邮件时间
                </div>
                <div class="search-item-comp">
                  <el-date-picker
                    size="small"
                    v-model="searchData.recentlyReadTime"
                    type="daterange"
                    value-format="timestamp"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="recentlydateChange"
                    :picker-options="readPickerOptions"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="search-item search-item-time">
                <div class="search-item-label" >
                  标签
                </div>
                <div class="search-item-comp">
                  <el-select
                    size="small"
                    multiple
                    filterable
                    collapse-tags
                    v-model="searchData.tags"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in tagList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="btns">
              <el-button size="small" @click="reset" class="smallBtn">清除筛选</el-button>
              <el-button
                size="small"
                style="width: 64px"
                type="primary"
                @click="search"
                >筛选</el-button
              >
            </div>
        </div>
      </div>
      <div class="content">
        <div  class="jumpEmaildiv">
          <span  class="jumpEmailSlect">已选 <span>{{handleSelectionList.length}}</span> 个</span>
          <span class="primaryBtn">
            <!-- :disabled="handleSelectionList.length==0" -->
            <el-button  size="small" class="smallBtn"  @click="jumpEmail" >发送邮件</el-button>
          </span>
        </div>
        <el-table
          ref="customerManagementPotentialTable"
          class="fine-scroll-bar"
          size="small"
          width="100%"
          :data="tableData"
          @sort-change="sortChange"
          v-loading="loading"
          :max-height="$store.state.userInfo.loginAsManagerId>0?'506px':'550px'"
          @selection-change="handleSelectionChange"
          tooltip-effect="light"
        >
          <template slot="empty">
            <div class="no-content-slot"></div>
          </template>
          <el-table-column
            type="selection"
            width="55" align="center">
          </el-table-column>
          <!-- 客户名称 -->
          <el-table-column
            fixed="left"
            min-width="200"
            label="客户名称"
            class-name="table-column-companyName"
          >
            <template slot-scope="scope">
              <div class="table-item-specialFocus" @mousemove.prevent>
                <el-tooltip
                  effect="light"
                  :content="scope.row.companyName"
                  placement="bottom"
                  popper-class="customer-management-potential-companyName-tooltip"
                  :disabled="isShowTooltip"
                >
                  <p
                    class="table-item-specialFocus-name"
                    @mouseover="
                      onMouseOver('specialFocusStrTootip' + scope.$index)
                    "
                  >
                    <span
                      :ref="'specialFocusStrTootip' + scope.$index"
                      style="color: #066eb7; cursor: pointer; width: 80%"
                      @click="openDetail(scope.row.id, scope.$index)"
                    >
                      {{ scope.row.companyName | noText }}
                    </span>
                  </p>
                </el-tooltip>
                <i
                  class="iconfont icon-icon-shoucang"
                  v-if="scope.row.attentionStatus == 20"
                ></i>
              </div>
            </template>
          </el-table-column>
          <!-- 标签 -->
          <el-table-column prop="3" min-width="220" label="标签">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="325"
                trigger="hover"
                v-if="scope.row.tagVos && scope.row.tagVos.length"
                popper-class="customer-management-tags-popover"
                :disabled="isShowTooltip"
              >
                <div class="table-item-tags-popover">
                  <span
                    v-for="item in scope.row.tagVos"
                    :key="item.id"
                    :style="{
                      backgroundColor: `rgba(${tagColors(item).rgb}, 0.1)`,
                      color: item.color,
                      fontSize:`12px`,
                    }"
                    >{{ item.name }}</span
                  >
                </div>
                <div
                  class="table-item-tags"
                  @mouseover="onMouseOver('tagsStrTootip' + scope.$index)"
                  slot="reference"
                >
                  <span :ref="'tagsStrTootip' + scope.$index">
                    <span
                      v-for="item in scope.row.tagVos"
                      :key="item.id"
                      :style="{
                        backgroundColor: `rgba(${tagColors(item).rgb}, 0.1)`,
                        color: item.color,fontSize:`12px`,
                      }"
                      >{{ item.name }}</span
                    >
                  </span>
                </div>
              </el-popover>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <!-- 主要联系人 -->
          <el-table-column min-width="120" label="联系人">
            <template slot-scope="scope">
              <el-popover
                popper-class="customer-management-potential-popover"
                v-if="scope.row.contacts && scope.row.contacts.length"
                placement="top-start"
                trigger="hover"
              >
                <div slot="reference">
                  {{ scope.row.contacts[0].contactName | noText }}
                </div>
                <div class="table-item-contacts fine-scroll-bar">
                  <div
                    class="li"
                    v-for="(item, index) in scope.row.contacts"
                    :key="index"
                  >
                    <div class="name">{{ item.contactName | noText }}</div>
                    <div class="mobile">
                      {{ item.mobile || item.tel ? item.areaCode : '' }}
                      {{ item.mobile || item.tel || '---' }}
                    </div>
                    <i
                      v-if="item.mobile || item.tel"
                      class="el-icon-document-copy"
                      v-copy="item.areaCode + ' ' + (item.mobile || item.tel)"
                    ></i>
                  </div>
                </div>
              </el-popover>
              <div v-else>---</div>
            </template>
          </el-table-column>
          <!-- 客户等级 -->
          <el-table-column
            prop="3"
            min-width="100"
            sortable="custom"
            label="客户等级"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.levelShow"
                :style="'color:' + levelComp(scope.row.level).color"
              >
                {{ scope.row.levelShow | noText }}
              </div>
              <div v-else>---</div>
            </template>
          </el-table-column>
          <!-- 所属行业 -->
          <el-table-column min-width="150px" label="所属行业">
            <template slot-scope="scope">
              <div>
                {{ scope.row.industryStr | noText }}
              </div>
            </template>
          </el-table-column>
          <!-- 跟进状态  -->
          <el-table-column
            prop="4"
            min-width="100"
            sortable="custom"
            label="跟进状态"
          >
            <template slot-scope="scope">
              <div class="table-item-followStatus">
                <i
                  :style="
                    scope.row.followStatus == 20
                      ? 'backgroundColor: #20B820'
                      : ''
                  "
                ></i>
                <span>{{ scope.row.followStatusShow | noText }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 国家 -->
          <el-table-column min-width="100" label="国家">
            <template slot-scope="scope">
              <div>{{ scope.row.country | noText }}</div>
            </template>
          </el-table-column>
          <!-- 省份  -->
          <el-table-column min-width="100" label="省份">
            <template slot-scope="scope">
              <div>{{ scope.row.state | noText }}</div>
            </template>
          </el-table-column>
          <!-- 城市  -->
          <el-table-column min-width="120" label="城市">
            <template slot-scope="scope">
              <div>{{ scope.row.city | noText }}</div>
            </template>
          </el-table-column>
          <!-- 客户来源 -->
          <el-table-column min-width="100" label="客户来源">
            <template slot-scope="scope">
              <div>{{ scope.row.sourceShow | noText }}</div>
            </template>
          </el-table-column>
          <!-- 最近阅读邮件时间  -->
          <el-table-column
            prop="8"
            sortable="custom"
            min-width="180"
            label="最近阅读邮件时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.recentlyReadTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 最后跟进时间  -->
          <el-table-column
            prop="2"
            sortable="custom"
            min-width="150"
            label="最后跟进时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.lastFollowupTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 客户添加时间  -->
          <el-table-column
            prop="1"
            sortable="custom"
            min-width="170"
            label="客户添加时间"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.createTime | format }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="no-content" v-if="!tableData || !tableData.length">
          <img src="@/assets/image/common/noData.png" alt="" />
          <p>暂无数据</p>
        </div>
        <div class="pagination">
          <el-pagination
            v-show="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="curPage"
            :page-size="pageSize"
            size="medium"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <DetailDrawer
      ref="detailDrawer"
      :companyDataProp="companyData"
      @emitAnewList="anewList"
      @getList="getList"
      :isAnalysis="isAnalysis"
    />
      <!-- 套餐购买 -->
      <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" :typeOpen="false"/>
  </div>
</template>

<script>
import DetailDrawer from '@/components/custom/DetailDrawer'
import TreeSelect from '@/components/common/TreeSelect'
import customerListMinxis from '@/mixins/customerList.js'
import { getProspectList } from '@/utils/api/customer.js'
import { getDictByType } from '@/utils/api/common.js'
import { industryByKeyword,sendEmailVerifyBulk,verifyBulkIdsConversion } from '@/utils/api/edmSubject'
import vipBoxDialog from "@/components/common/VIPdialog"
export default {
  components: {
    TreeSelect,
    DetailDrawer,
    vipBoxDialog
  },
  mixins: [customerListMinxis],
  computed: {},
  data() {
    return {
      isAnalysis:true,
      tabPosition: '',
      checked1: false,
      isUnfold: true,
      isCustomerFollow: false,
      sort: {},
      followStatus: 0, // 客户状态
      searchData: {
        keyword: '',
        tags: [], // 标签
        // source: [], // 来源
        industry: [], // 所属行业
        level: [], // 客户等级
        area: [], // 区域
        dateData: [],
        startTime: '',
        endTime: '',
        areaNotes: [],
        keySelectValue: 'companyName',
        recentlyReadTime:[],
        emailReadStartTime:'',//阅读邮件开始时间
        emailReadEndTime:'',//阅读邮件结束时间
        uuid:''
      },
      copySearchData: {},
      customerSourceOptions: [],
      customerLevelOptions: [],
      customerIndustryOptions: [],
      currencyOptions: [],
      dateData: {},
      companyData: {
        id: null,
        ids: [],
        index: null,
      },
      companyIds: [],
      companyIndex: null,
      treeSelectShow: true,
      tagList:[],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近两周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一个月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 1)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近三个月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 3)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近半年',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 6)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一年',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setFullYear(start.getFullYear() - 1)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      readPickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              start.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start , start])
            },
          },
          {
            text: '近三天',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              start.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近两周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一个月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 1)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      handleSelectionList:[],
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      sendEmailDis:true,

      curPage: 1,
      pageSize: 100
    }
  },
  methods: {
    // 表格多选
    handleSelectionChange(val) {
      console.log(val)
      this.handleSelectionList=[]
      val.map((item)=>{
        this.handleSelectionList.push(item.id)
      })
      console.log(this.handleSelectionList)
    },
    // 发送邮件
    jumpEmail(){
      if(this.handleSelectionList.length==0){
        this.$message.error('请至少选择一个客户')
      }else{
        if( this.sendEmailDis){
          this.sendEmailDis=false
          let params={
            ids:this.handleSelectionList
          }
          verifyBulkIdsConversion(params).then((res)=>{
            if(res.rspResult.bizCode==200){
              this.uuid=res.data.value
              let bodys={
                uuid:this.uuid
              }
              sendEmailVerifyBulk(bodys).then(res=>{
                if(res.rspResult.bizCode==200){
                  console.log(res)
                  let routeUrl = this.$router.resolve({
                    name:`potentialSendEmail`,
                    query:{
                      customerIds: this.uuid,
                    }
                  }).href
                  window.open(routeUrl, '_blank');
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
                  this.vipCode=res.rspResult.bizCode
                  this.$refs.vipBoxDialog.centerDialogVisible=true
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }else{
                  this.$message.error(res.rspResult.message)
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }
              })
            }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
              this.vipCode=res.rspResult.bizCode
              this.$refs.vipBoxDialog.centerDialogVisible=true
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }else{
              this.$message.error(res.rspResult.message)
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }
          })
        }

      }
    },
    // 展开、 收起
    handleUnfold() {
      this.isUnfold = !this.isUnfold
      const ref = this.$refs.shrink
      if (this.isUnfold) {
        ref.style.height = '170px'
        ref.style.borderTop = '1px solid #E5E8ED'
      } else {
        ref.style.height = '0'
        ref.style.borderTop = '1px solid #fff'
      }
    },
    // 当区域选择器值发生改变时
    areaCheckChange(arr, notes) {
      this.searchData.area = JSON.parse(JSON.stringify(arr))
      this.searchData.areaNotes = JSON.parse(JSON.stringify(notes))
    },

    // 获取列表数据
    async getList(isTop = true) {
      this.loading = true
      try {
        const params = {
          ...this.copySearchData,
          followStatus: this.followStatus || undefined, // 客户状态
          attentionStatus: this.attentionStatus || undefined, // 特别关注
          pageSize: this.pageSize,
          curPage: this.curPage,
          ...this.sort,
          industry: this.copySearchData.industry || [],
          dateType: 1, // 日期搜索类型，目前只有创建时间
          // 以下代码清除不需要的入参，避免带入接口
          dateData: undefined,
          areaNotes: undefined,
          dateData: undefined,
          recentlyReadTime: undefined,
          keySelectValue: undefined,
          keyword: this.copySearchData.keyword.trim(),
          // attribute:8,
        }

        // 判断，如果选择的不是标签
        // if (this.copySearchData.keySelectValue) {
        //   params.tags = undefined
        //   params[this.copySearchData.keySelectValue] =
        //     this.copySearchData.keyword.trim()
        // }
        const res = await getProspectList(params)
        if (res.rspResult.bizCode === 200) {
          this.tableData = res.rspPageData.list
          this.total = res.rspPageData.totalNum
          if (isTop) this.returnTop()
        } else {
          this.total = 0
        }
        this.loading = false
      } catch (err) {
        this.total = 0
        this.loading = false
        console.error('❌ ~ file: potential.vue:588 ~ getList ~ err:', err)
      }
    },

    // 当客户状态发生变化时
    followStatusChange() {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.curPage = 1
      this.recoverArea()
      this.getList()
    },

    // 恢复区域选择器的选中项和字符串展示
    recoverArea() {
      try {
        const tree = this.$refs.treeSelect
        tree.recoverArea(
          this.copySearchData.area,
          this.copySearchData.areaNotes
        )
      } catch (err) {
        console.error('❌ ~ file: potential.vue:611 ~ recoverArea ~ err:', err)
      }
    },

    // 初始化选项数据
    async getInitData() {
      try {
        const res = await getDictByType([
          // { key: 'saas_supplier_customer_source' },
          { key: 'saas_supplier_customer_level' },
          { key: 'currency' },
        ])
        if (res.rspResult.bizCode === 200) {
          const {
            codeMap: {
              // saas_supplier_customer_source,
              saas_supplier_customer_level,
              currency,
            },
          } = res.data
          // this.customerSourceOptions = saas_supplier_customer_source || []
          this.customerLevelOptions = saas_supplier_customer_level || []
          this.currencyOptions = currency || []
        }
      } catch (err) {
        console.error('❌ ~ file: potential.vue:639 ~ getInitData ~ err:', err)
      }
    },

    // 日期切换时
    dateChange() {
      if (this.searchData.dateData) {
        this.searchData.startTime = this.searchData.dateData[0]
        this.searchData.endTime = this.searchData.dateData[1]
      } else {
        this.searchData.startTime = ''
        this.searchData.endTime = ''
      }
    },
    // 阅读邮件时间
    recentlydateChange(){
      if (this.searchData.recentlyReadTime) {
        this.searchData.emailReadStartTime = this.searchData.recentlyReadTime[0]
        this.searchData.emailReadEndTime = this.searchData.recentlyReadTime[1]
      } else {
        this.searchData.emailReadStartTime = ''
        this.searchData.emailReadEndTime = ''
      }
    },

    // 重置
    reset() {
      this.searchData = {
        keyword: '',
        tags: [], // 标签
        // source: [], // 来源
        industry: [], // 所属行业
        level: [], // 客户等级
        area: [], // 区域
        dateData: [],
        startTime: '',
        endTime: '',
        areaNotes: [],
        keySelectValue: 'companyName',
        recentlyReadTime:'',
        emailReadStartTime:'',//阅读邮件开始时间
        emailReadEndTime:'',//阅读邮件结束时间
      }
      this.copySearchData = JSON.parse(JSON.stringify(this.searchData))
      this.$refs.customerManagementPotentialTable.clearSort()
      this.sort = {}
      // 清空区域选择器
      try {
        this.treeSelectReset()
      } catch (err) {
        console.error('❌ ~ file: potential.vue:676 ~ reset ~ err:', err)
      }
      this.curPage = 1
      this.pageSize = 10
      this.getList()
    },

    treeSelectReset() {
      return this.$refs.treeSelect.deleteData()
    },

    findIndustryData() {
      const params = {
        keyword: '',
      }
      this.customerIndustryOptions = []
      industryByKeyword(params).then((res) => {
        if (res.rspResult.bizCode == 200) {
          this.customerIndustryOptions = res.rspListData.list
        }
      }).catch((err) => {
        console.error("❌ ~ file: potential.vue:787 ~ industryByKeyword ~ err:", err)
      })
    },

  },
  created() {
    this.copySearchData = JSON.parse(JSON.stringify(this.searchData))
    this.getList()
    this.getInitData()
    this.getInitTagList()
    this.findIndustryData()
  },
  mounted(){
    if(this.$route.query.customerId){
      this.isAnalysis=false
      this.companyData = {
        id:this.$route.query.customerId,
        ids: [this.$route.query.customerId],
        index:0,
      }
      const ref = this.$refs.detailDrawer
      ref.isList = true
      ref.isCustomerDetail = true
      ref.visible = true
    }
  }
}
</script>

<style lang="scss" src="./style/potential.scss" scoped></style>
<style lang="scss" scoped>
::v-deep .search-item-specialNew{
  input {
    width: 275px;
    border-radius: 4px 0 0 4px !important;
  }
}
.jumpEmaildiv{
  margin-left: 22px;
  margin-bottom: 12px;
  .jumpEmailSlect{
    font-size: 14px;
    color: #16181a;
    span{
      color: #066EB7;
      font-size: 14px;
    }
  }
  .primaryBtn{
    margin-left: 32px;
    font-size: 14px;
    color: #4F5D78;

  }
}
.smallBtn{
  font-size: 14px;
  color: #4F5D78;
}
.smallBtn:hover{
  font-size: 14px;
  color: #4F5D78;
  border: 1px solid #066eb7;
  background: #066eb71a;
  /* border-left-width: 0; */
  color: #066eb7;
}
::v-deep .pagination{
  .el-pagination{
    .el-pagination__total{
      color: #4f5d78;
    }
  }
}
</style>
<style lang="scss">
.customer-management-potential-companyName-tooltip.is-light[x-placement^='bottom']
  .popper__arrow {
  border-color: #ebeef5 !important;
}
.customer-management-tags-popover {
  padding-bottom: 0;
  max-height: 237px;
  overflow-y: auto;
  overflow-x: hidden;
  @import '@/assets/css/common.scss';
  @include fine-scroll-bar;
  .popper__arrow {
    display: none;
  }
}
</style>
